import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggleToDark", "toggleToLight"];

  connect() {
    this.changeToggleIcon();
    this.setTheme(savedTheme());
  }

  toggle() {
    const html = document.documentElement;
    const newTheme = html.classList.contains("dark") ? "light" : "dark";
    this.setTheme(newTheme);
    this.changeToggleIcon();
  }

  setTheme(theme) {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
    localStorage.setItem("louvorpro-theme-config", theme);
  }

  changeToggleIcon() {
    if (savedTheme() === "dark") {
      this.toggleToLightTarget.classList.remove("hidden");
      this.toggleToDarkTarget.classList.add("hidden");
    } else {
      this.toggleToDarkTarget.classList.remove("hidden");
      this.toggleToLightTarget.classList.add("hidden");
    }
  }
}
